export const styles = {
  container: {
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: "20px",
    maxWidth: "600px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
    marginTop: "20px"
  },
  requirementsBox: {
    backgroundColor: "#f8f9fa",
    padding: "12px",
    borderRadius: "6px",
    marginBottom: "20px"
  },
  input: {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    fontSize: "14px"
  },
  heading: {
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: "10px"
  },
  description: {
    color: "#666",
    marginBottom: "20px",
    fontSize: "14px"
  },
  successBox: {
    marginTop: "20px",
    padding: "16px",
    backgroundColor: "#f0fdf4",
    border: "1px solid #86efac",
    borderRadius: "8px"
  },
  errorBox: {
    marginTop: "20px",
    padding: "16px",
    backgroundColor: "#fef2f2",
    border: "1px solid #fca5a5",
    borderRadius: "8px"
  },
  successHeading: {
    fontWeight: 600,
    fontSize: "19px",
    color: "#166534",
    marginBottom: "8px"
  },
  errorHeading: {
    fontWeight: 600,
    color: "#dc2626",
    marginBottom: "8px"
  },
  // Common wrapper styles
  inputWrapper: {
    marginBottom: "20px"
  },
  buttonGroup: {
    marginBottom: "20px",
    display: "flex",
    gap: "10px"
  },
  loadingText: {
    marginBottom: "20px",
    fontSize: "14px",
    color: "#666"
  }
};
